import request from '@/utils/request';

//商品推荐列表
export const dataAnalysisProductRecommendConfigList = (data: any): any =>
request({
	url: '/pc/dataAnalysisProductRecommendConfig/list',
	data: data
})


//商品推荐 添加商品
export const dataAnalysisProductRecommendConfigSaveProduct = (data: any): any =>
request({
	url: '/pc/dataAnalysisProductRecommendConfig/saveProduct',
	data: data
})


//商品推荐 设置推荐理由
export const dataAnalysisProductRecommendConfigSaveRecommendReason = (data: any): any =>
request({
	url: '/pc/dataAnalysisProductRecommendConfig/saveRecommendReason',
	data: data
})

//商品推荐 设置排序
export const dataAnalysisProductRecommendConfigSaveSortDesc= (data: any): any =>
request({
	url: '/pc/dataAnalysisProductRecommendConfig/saveSortDesc',
	data: data
})

//商品推荐 取消推荐
export const dataAnalysisProductRecommendConfigCancelRecommend= (data: any): any =>
request({
	url: '/pc/dataAnalysisProductRecommendConfig/cancelRecommend',
	data: data
})

//操作日志
export const dataAnalysisEmployeeOperatorOperationLogList = (data: any): any =>
request({
	url: '/pc/dataAnalysisEmployeeOperatorOperationLog/list',
	data: data
})



//运营者管理-列表
export const employeeOperatorConfigList = (data: any): any =>
request({
	url: '/pc/dataAnalysis/employeeOperatorConfigList',
	data: data
})

//运营者管理-详情
export const employeeOperatorConfigInfo = (data: any): any =>
request({
	url: '/pc/dataAnalysis/employeeOperatorConfigInfo',
	data: data
})


//运营者管理-弹框代理列表
export const dataAnalysischoseMemberBox = (data: any): any =>
request({
	url: '/pc/dataAnalysis/choseMemberBox',
	data: data
})

//运营者管理 保存配置
export const employeeOperatorConfigSave = (data: any): any =>
request({
	url: '/pc/dataAnalysis/employeeOperatorConfigSave',
	data: data
})

//运营者管理 取消权限
export const employeeOperatorConfigDelete = (data: any): any =>
request({
	url: '/pc/dataAnalysis/employeeOperatorConfigDelete',
	data: data
})

//获取员工列表
export const employeeList = (data: any): any =>
request({
	url: '/pc/dataAnalysis/employeeList',
	data: data
})

export const activityPKRankingList = (data: any): any =>
request({
	url: '/pc/activityPKRanking/list',
	data: data
})
export const activityPKRankingSave = (data: any): any =>
request({
	url: '/pc/activityPKRanking/save',
	data: data
})
export const entrancePosterImgSortDescEdit = (data: any): any =>
request({
	url: '/pc/activityPKRanking/entrancePosterImgSortDescEdit',
	data: data
})
export const entrancePosterImgIsShowEdit = (data: any): any =>
request({
	url: '/pc/activityPKRanking/entrancePosterImgIsShowEdit',
	data: data
})
export const activityPKRankingDelete = (data: any): any =>
request({
	url: '/pc/activityPKRanking/delete',
	data: data
})
export const activityPKRankingInfo = (data: any): any =>
request({
	url: '/pc/activityPKRanking/info',
	data: data
})
export const chooseMemberList = (data: any): any =>
request({
	url: '/pc/activityPKRanking/chooseMemberList',
	data: data
})

